import { AfterViewInit, Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { BaseComponent } from 'src/app/core/base.component';
import { StringHelpers } from 'src/app/shared/helpers/string-helpers';
import { GlobalDataService } from 'src/app/shared/services/global-data.service';
import { SessionService } from 'src/app/shared/services/session.service';
import { SponsorType } from '../sponsor-type.enum';
import { SponsorService } from '../sponsor.service';

@Component({
    selector: 'app-sponsor-create',
    templateUrl: './sponsor-create.component.html',
    styleUrls: ['./sponsor-create.component.scss'],
    standalone: false
})
export class SponsorCreateComponent extends BaseComponent implements OnInit, AfterViewInit {

  public canCreateSponsor: boolean;
  public sponsorTypes = SponsorType;
  public sponsors: SponsorType; 

  public form = new FormGroup({
    name: new FormControl('',{
      validators: Validators.required
    }),
    company: new FormControl(''),
    contactEmail: new FormControl('',{
    validators: Validators.required
    }),
    requestReceipt: new FormControl(false),
    amount: new FormControl(),
    type: new FormControl(SponsorType.Donation),
    notes: new FormControl(''),
    outingIterationId: new FormControl(),
    createdBy: new FormControl(),
  });

  constructor(public sessionService: SessionService,
    private sponsorService: SponsorService,
    private globalDataService: GlobalDataService,
    stringHelpers: StringHelpers,
    private router: Router) {
    super(sessionService, stringHelpers);
   }

  ngOnInit(): void {
    if(this.isGlobalOutingSet()){
      this.selectedIteration = this.getGlobalOutingIteration();
      this.canCreateSponsor = true;
    }
  }

  ngAfterViewInit(): void {
    this.globalDataService.iterationSelectionEvent.subscribe(result => {
      this.selectedIteration = result;
      this.canCreateSponsor = true;
    });
  }

  keys(): Array<string>{
    var keys = Object.keys(SponsorType);
    var test = keys.slice(keys.length / 2, keys.length)
    return test;
  }

  parseEnumValue(value: string){
    switch(value.toLowerCase()){
      case 'holesponsor': 
        return 'Hole Sponsor';
      case 'cartsponsor':
        return 'Cart Sponsor';
      default:
        return value;
    }
  }

  parseEnumKey(value: string){
    switch(value.toLowerCase()){
      case 'holesponsor': 
        return 1;
      case 'cartsponsor':
        return 2;
      case 'donation':
        return 3;
      case 'team':
        return 4;
      case 'other':
        return 5;
      default:
        return value;
    }
  }

  onSubmit({ value, valid }) {
    if (valid) {
      this.isLoading = true;
      value.createdBy = this.sessionService.getUserId();
      value.outingIterationId = this.selectedIteration.id;
      this.sponsorService.create(value).subscribe(() => {
        this.isLoading = false;
        this.form.reset();
        this.form.clearAsyncValidators();
        this.form.clearValidators();
        this.isLoading = false;
        this.router.navigate(['/outing-management/administration/sponsors']);
      }, (err: any) => {
        this.isLoading = false;
        if (err.status === 400) {
          this.setError(err, this.form);
        }
      });
    }
  }
}
